<template>
  <amenity-manatee
    :style="{ transform: 'rotate(' + turn + 'turn)' }"
  ></amenity-manatee>
</template>

<script>
export default {
  props: {},
  mounted() {
    this.updateTurn();
  },

  methods: {
    updatePauseLength() {
      if (this.turnDirection === 1) {
        this.pauseLength = 100;
      } else {
        this.pauseLength = 10;
      }
    },
    updateTurn() {
      setTimeout(() => {
        if (this.turnDirection === 1) {
          this.turn -= 0.016;
          if (this.turn < -.4) {
            this.turnDirection = 0;
          }
        } else {
          this.turn += 0.08;
        }

        this.updateTurn();
        this.updatePauseLength();
      }, this.pauseLength);
    },
  },
  computed: {},
  data() {
    return {
      turn: 0,
      turnDirection: 1,
      pauseLength: 25,
    };
  },
};
</script>
